import React, { useEffect, useState } from "react";
import { LuEye, LuEyeOff } from "react-icons/lu";
import Swal from "sweetalert2";
import userService from "../../services/UserService";
import Button from "../Button/button";
import InputComponent from "../Input/input";
import { Label } from "../Label/styles";
import {
  BlueTitle,
  ButtonGroupStart,
  Column,
  ModalBody,
  ModalBodyContainer,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Space,
  StyledHR,
} from "../../shared/styles/global.styles";
import { IoCloseSharp } from "react-icons/io5";
import {
  InputContainer,
  PasswordContainer,
  RowContainer,
  StyledInput,
  StyledSpan,
  Switch,
  SwitchRow,
} from "./cadastroUsuarioModal.styles";
import { CreateControleAcessoDto } from "../../shared/dtos/ControleAcesso.dto";
import { CreateUserDto } from "../../shared/dtos/Usuario.dto";
import { ModulosDto } from "../../shared/dtos/Modulos.dto";
import { PermissoesDto } from "../../shared/dtos/Permissoes.dto";
import permissoesService from "../../services/PermissoesService";
import modulosService from "../../services/ModulosService";
import {
  Table,
  TableContainer,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
} from "../Table/styles";

interface CadastroModalProps {
  onClose: () => void;
  onSuccess: () => void;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const CadastroUsuarioModal: React.FC<CadastroModalProps> = ({
  onClose,
  onSuccess,
  showModal,
  setShowModal,
}) => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [controleAcesso, setControleAcesso] = useState<
    CreateControleAcessoDto[]
  >([]);
  const [useDefaultPassword, setUseDefaultPassword] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
  const [modulos, setModulos] = useState<ModulosDto[]>();
  const [permissoes, setPermissoes] = useState<PermissoesDto[]>();
  const [errors, setErrors] = useState<{
    name?: string;
    email?: string;
    password?: string;
    permission?: string;
  }>({});

  const validateFields = () => {
    const newErrors: {
      name?: string;
      email?: string;
      password?: string;
      permission?: string;
      controleAcesso?: string;
    } = {};

    if (!name.trim()) {
      newErrors.name = "Nome é obrigatório";
    }

    if (!email.trim()) {
      newErrors.email = "E-mail é obrigatório";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "E-mail inválido";
    }

    if (!useDefaultPassword && !password.trim()) {
      newErrors.password = "Senha é obrigatória";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      Swal.fire({
        title: "Erro",
        text: "Por favor, preencha todos os campos obrigatórios.",
        icon: "error",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      });
      return false;
    } else {
      if (controleAcesso.length === 0) {
        Swal.fire({
          title: "Erro",
          text: "Por favor, selecione pelo menos uma permissão.",
          icon: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
        return false;
      }
    }
    return true;
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "password":
        setPassword(value);
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = () => {
    setIsActive((prev) => !prev);
  };

  // Buscar modulos
  const fetchModulos = async () => {
    try {
      const data = await modulosService.getAllModulos();
      setModulos(data);
    } catch (error) {
      console.error("Erro ao buscar modulos:", error);
      Swal.fire(
        "Erro",
        "Erro ao carregar os modulos. Tente novamente mais tarde.",
        "error"
      );
    }
  };

  // Buscar permissões
  const fetchPermissoes = async () => {
    try {
      const data = await permissoesService.getAllPermissoes();
      setPermissoes(data);
    } catch (error) {
      console.error("Erro ao buscar modulos:", error);
      Swal.fire(
        "Erro",
        "Erro ao carregar os modulos. Tente novamente mais tarde.",
        "error"
      );
    }
  };

  const handleDefaultPasswordChange = () => {
    setUseDefaultPassword((prev) => {
      const newValue = !prev;
      if (newValue) {
        setPassword("SantaCasa@123");
      } else {
        setPassword("");
      }
      return newValue;
    });
  };

  const clearInputs = () => {
    // Reseta os campos
    setName("");
    setEmail("");
    setPassword("");
    setIsActive(false);
    setUseDefaultPassword(false);
  };

  const handleSubmit = async () => {
    setIsSubmiting(true);
    if (!validateFields()) {
      setIsSubmiting(false);
      return;
    }

    setIsSubmiting(true);
    const userData: CreateUserDto = {
      name,
      email,
      password: useDefaultPassword ? "SantaCasa@123" : password,
      isActive,
    };

    Swal.fire({
      title: "Aguarde",
      text: "Cadastrar novo usuário, por favor aguarde",
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      await userService.register(userData, controleAcesso);

      Swal.close();
      Swal.fire({
        title: "Cadastro realizado!",
        text: useDefaultPassword
          ? "Usuário cadastrado com sucesso! A senha padrão é: SantaCasa@123"
          : "Usuário cadastrado com sucesso!",
        icon: "success",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      }).then(() => {
        clearInputs();
        onSuccess();
        setShowModal(false);
        setIsSubmiting(false);
      });
    } catch (error: any) {
      console.error("Erro ao cadastrar:", error);
      Swal.close();

      // Verifica se é um erro de chave duplicada (email)
      if (
        error.response?.data?.message?.includes("duplicate") ||
        error.message?.includes("duplicate") ||
        error.response?.data?.message?.includes("já está em uso")
      ) {
        Swal.fire({
          title: "Email já cadastrado",
          text: "Esse email já está sendo usado por outro usuário(a). Por favor, utilize um email diferente.",
          icon: "warning",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      } else {
        // Outros tipos de erro
        const errorMessage =
          error.response?.data?.message ||
          "Ocorreu um erro inesperado. Por favor, tente novamente ou entre em contato com o suporte.";

        Swal.fire({
          title: "Erro no cadastro",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
        });
      }

      setIsSubmiting(false);
    }
  };

  useEffect(() => {
    fetchModulos();
    fetchPermissoes();
  }, []);

  return (
    <ModalContainer show={showModal}>
      <ModalContent width={60}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => setShowModal(false)}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Cadastrar novo usuário</BlueTitle>
        </ModalHeader>

        <ModalBody>
          {/* Campos de entrada */}
          <Column>
            <RowContainer>
              <InputContainer>
                <Label htmlFor="name">Nome completo</Label>
                <InputComponent
                  type="text"
                  id="inputName"
                  name="name"
                  value={name.toUpperCase()}
                  onChange={handleInputChange}
                  placeholder="Insira o nome completo"
                  color="#333"
                  errorMessage={errors.name}
                />
              </InputContainer>
              <InputContainer>
                <Label htmlFor="email">E-mail</Label>
                <InputComponent
                  type="email"
                  id="inputEmail"
                  name="email"
                  value={email ? email.toLowerCase() : email}
                  onChange={handleInputChange}
                  placeholder="Insira o e-mail"
                  color="#333"
                  errorMessage={errors.email}
                />
              </InputContainer>
            </RowContainer>
            <RowContainer>
              <InputContainer>
                <Label>Senha</Label>
                <PasswordContainer>
                  <InputComponent
                    type={showPassword ? "text" : "password"}
                    placeholder="Digite sua senha"
                    name="password"
                    value={useDefaultPassword ? "SantaCasa@123" : password}
                    onChange={handleInputChange}
                    color="#333"
                    id="password"
                    disabled={useDefaultPassword}
                    errorMessage={
                      !useDefaultPassword ? errors.password : undefined
                    }
                    iconRight={
                      showPassword ? (
                        <LuEyeOff
                          onClick={() => setShowPassword(false)}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <LuEye
                          onClick={() => setShowPassword(true)}
                          style={{ cursor: "pointer" }}
                        />
                      )
                    }
                  />
                </PasswordContainer>
              </InputContainer>
              <Space />
              {/* <Label htmlFor="permission">Permissão</Label>
              <SelectComponent
                id="selectPermission"
                name="permission"
                value={permission}
                onChange={(e) => setPermission(e.target.value)}
                width={336}
                color="black"
                placeholder="Selecione uma permissão"
                options={[
                  { value: UsersEnumType.ADMIN, label: "Administrador" },
                  { value: UsersEnumType.CASH, label: "Caixa" },
                  { value: UsersEnumType.USER, label: "Usuário" },
                ]}
                errorMessage={errors.permission}
              />
              <Space /> */}
              <SwitchRow>
                <Switch>
                  <StyledInput
                    type="checkbox"
                    checked={isActive}
                    onChange={handleCheckboxChange}
                  />
                  <StyledSpan />
                </Switch>
                <span style={{ marginLeft: "10px" }}>
                  {isActive ? "Usuário Ativo" : "Usuário Inativo"}
                </span>
              </SwitchRow>
            </RowContainer>
            <BlueTitle fontSize={18}>Permissões de acesso:</BlueTitle>
            <TableContainer>
              <Table id="permissoes-table">
                <TableHead>
                  <TableRow>
                    <TableHeader style={{ width: "150px" }}>Tela</TableHeader>
                    <TableHeader style={{ width: "100px" }}>
                      Permissões
                    </TableHeader>
                  </TableRow>
                </TableHead>
                <tbody>
                  {modulos && modulos.length > 0 ? (
                    modulos.map((modulo) => (
                      <TableRow key={modulo.id}>
                        <TableData>{modulo.nome}</TableData>

                        <TableData
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          {permissoes?.map((permissao) => (
                            <div
                              key={permissao.id}
                              style={{
                                display: "inline-block",
                                marginRight: "1rem",
                                verticalAlign: "middle",
                              }}
                            >
                              <Switch>
                                <StyledInput
                                  type="checkbox"
                                  id={`permissao-${modulo.id}-${permissao.id}`}
                                  checked={controleAcesso.some(
                                    (controle) =>
                                      controle.idModulos === modulo.id &&
                                      controle.idPermissoes === permissao.id
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const controleAcessoAtual =
                                      controleAcesso ?? [];

                                    const updatedControleAcesso = isChecked
                                      ? permissao.id === 1
                                        ? [
                                            ...controleAcessoAtual,
                                            {
                                              idModulos: modulo.id,
                                              idPermissoes: 1,
                                            },
                                            {
                                              idModulos: modulo.id,
                                              idPermissoes: 2,
                                            },
                                          ]
                                        : [
                                            ...controleAcessoAtual,
                                            {
                                              idModulos: modulo.id,
                                              idPermissoes: permissao.id,
                                            },
                                          ]
                                      : controleAcessoAtual.filter(
                                          (controle) => {
                                            // If trying to uncheck permission 2 and permission 1 is checked, keep permission 2
                                            if (
                                              permissao.id === 2 &&
                                              controleAcessoAtual.some(
                                                (c) =>
                                                  c.idModulos === modulo.id &&
                                                  c.idPermissoes === 1
                                              ) &&
                                              controle.idModulos ===
                                                modulo.id &&
                                              controle.idPermissoes === 2
                                            ) {
                                              return true;
                                            }

                                            return !(
                                              controle.idModulos ===
                                                modulo.id &&
                                              controle.idPermissoes ===
                                                permissao.id
                                            );
                                          }
                                        );

                                    setControleAcesso(updatedControleAcesso);
                                  }}
                                />

                                <StyledSpan />
                              </Switch>
                              <label
                                htmlFor={`permissao-${modulo.id}-${permissao.id}`}
                                style={{ marginLeft: "5px" }}
                              >
                                {permissao.role}
                              </label>
                            </div>
                          ))}
                        </TableData>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableData colSpan={2} style={{ textAlign: "center" }}>
                        Nenhum tela encontrada.
                      </TableData>
                    </TableRow>
                  )}
                </tbody>
              </Table>
            </TableContainer>
          </Column>
        </ModalBody>
        <ModalFooter>
          <Button type="button" schemaButton="out-danger" action={onClose}>
            Cancelar
          </Button>
          <Button
            type="button"
            schemaButton={
              isSubmiting || isActive ? "full-primary" : "full-disabled"
            }
            action={handleSubmit}
            disabled={!isActive || isSubmiting}
          >
            Cadastrar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default CadastroUsuarioModal;
